module.exports = __webpack_public_path__ + "img/138.4052e278.jpg";